import React, { useEffect, useRef } from 'react';
import { Youtube as YoutubeCommon } from '@bizzabo/broadcast';
import FeatureToggleUtils from 'FeatureToggleUtils';

const verifyYouTubeScriptExists = (yuotubeApiScriptId) => !!document.getElementById(yuotubeApiScriptId);

const loadYouTubeIframeApi = (yuotubeApiScriptId) => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.id = yuotubeApiScriptId;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

export const Youtube = ({ streamId, isIframeLoading, setIsIframeLoading, isMobileApp = false, canPlay = true }) => {
    const isYoutubeCommonEnabled = FeatureToggleUtils.isFeatureEnabled('broadcastPlayerYoutube');

    const playerRef = useRef(null);

    if (isYoutubeCommonEnabled) {
        return isMobileApp ?
            <YoutubeCommon
                streamId={streamId}
            />
            :
            <div style={{flex: 2, padding: '56.25% 0 0 0', position: 'relative'}}>
                {isIframeLoading && <i className="iframe-broadcast-spinner fa fa-spinner fa-spin fa-2x"/>}
                <YoutubeCommon
                    streamId={streamId}
                    onLoad={() => setIsIframeLoading(false)}
                />
            </div>;
    }
    const url = `https://www.youtube.com/embed/${streamId}?autoplay=1&playsinline=1&enablejsapi=1`;

    useEffect(
        () => {
            const yuotubeApiScriptId = 'youtubeApiScriptId';

            if (!verifyYouTubeScriptExists(yuotubeApiScriptId)) {
                loadYouTubeIframeApi(yuotubeApiScriptId);
            }

            const onPlayerReady = (event) => {
                canPlay && event.target?.playVideo();
            };

            if (streamId) {
                const onYouTubeIframeAPIReady = () => {
                    if (window?.YT?.Player) {
                        playerRef.current = new window.YT.Player(streamId, {
                            events: {
                                'onReady': onPlayerReady,
                            }
                        });
                    }
                };

                window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
            }
        },
        [streamId]
    );

    useEffect(() => {
        if (canPlay) {
            playerRef.current?.playVideo();
        }
    }, [canPlay]);

    return isMobileApp ?
        (
            <iframe
                id={streamId}
                src={url}
                frameBorder="0"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                allowFullScreen
                allow="autoplay; encrypted-media"
            />
        ) :
        (
            <div style={{ flex: 2, padding: '56.25% 0 0 0', position: 'relative' }}>
                {isIframeLoading && <i className="iframe-broadcast-spinner fa fa-spinner fa-spin fa-2x" />}
                <iframe
                    id={streamId}
                    src={url}
                    frameBorder="0"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    onLoad={() => setIsIframeLoading(false)}
                    allow="autoplay; encrypted-media"
                />
            </div>
        );
};
